import React from 'react'
import ImageStore from '../../stores/image-store'
import ProductStore from '../../stores/product-store'
import createReactClass from 'create-react-class'


var _activeImageFilter = '{}';
var _applyingFilter = false;

/**
 * The OrderImagePreview component is used to display a preview of an order-item from the order.
 * This component is used in the order-list's thumbnail on the editor-page and on the upsale-page
 * To work properly props for width and height should be passed into the component, optional props are
 * wrapperClass and imageClass which will set the className for the wrapper(div) element and the image element
 */
var OrderImagePreview = createReactClass({
	getDefaultProps: function() {
		// In case no width/height props are passed into the component
		return {
			width: 100,
			height: 100,
			wrapperClass: '',
			imageClass: '',
			imageSource: null
		};
	},
	_resizeImageToFitContainer: function(imageWidth, imageHeight, containerWidth, containerHeight, angle) {
		// Resize the image elements to fit the selectionSize
		var item = this.props.item,
			widthRatio, heightRatio, imageRatio,
			newWidth, newHeight, containerRatio;

		if(!angle) angle = 0;

		widthRatio = containerWidth / imageWidth;
		heightRatio = containerHeight / imageHeight;
		imageRatio = imageWidth / imageHeight;
		containerRatio = containerWidth / containerHeight;
		// If image is wider than the container
		if(heightRatio > widthRatio) {
			newHeight = imageHeight * heightRatio;
			newWidth = containerHeight * imageRatio;
		}
		// Else if the image ratio is narrower than the container
		else {
			newWidth = imageWidth * widthRatio;
			newHeight = containerWidth / imageRatio;
		}

		return { width: newWidth, height: newHeight };
	},



	/**
	 * Method for calculating and returning the appropriate wrapper size for the image preview.
	 * The size of the wrapper is based on the format of the selected image as well as depending on
	 * if the image is a portrait and/or any potential rotation of the image
	 * return {obj} - containing a width and height property
	 */
	getPreviewStyle: function() {
		var settings = {},
			item = this.props.item,
			prodKey = (item.options.productHeight + 'x' + item.options.productWidth).toString(),
			productOptions = ProductStore.getProductById(item.productId).options,
			productWidth = parseFloat(item.options.productWidth),
			productHeight = parseFloat(item.options.productHeight),
			fillerWidth = 0, fillerHeight = 0,
			width = 0, height = 0,
			maxWidth = this.props.width,
			maxHeight = this.props.height;

		var wrapperStyle = {
			width: this.props.width,
			height: this.props.height,
			position: 'relative'
		};

		var customSettings = item.getCustomSettings();
		var aspectRatio = item.isPortrait && !customSettings ? productHeight / productWidth : productWidth / productHeight;

		try {
			var angle = item.options.imageFilter.rotate.angle;
		} catch (e) {}

		width = maxWidth;
		height = width / aspectRatio;

		if(height > maxHeight) {
			height = maxHeight;
			width = height * aspectRatio;
		}

		if(customSettings) {
			var widthAspect = customSettings.canvasWidth / productWidth;
			var heightAspect = customSettings.canvasHeight / productHeight;
			// Scale down the size of the canvas to fit within the product
			width = width * widthAspect;
			height = height * heightAspect;
			fillerHeight = height / heightAspect;
			fillerWidth = width / widthAspect;

			// Recalculate if width exceeds maxHeight
			if(fillerWidth > maxWidth) {
				// Scale down the size
				var aspect = fillerWidth / maxHeight;

				fillerWidth = height / heightAspect;
				fillerHeight = width / widthAspect;

				fillerWidth = fillerWidth / aspect;
				fillerHeight = fillerHeight / aspect;

				width = width / aspect;
				height = height / aspect;
			}
			else {
				fillerHeight = height / heightAspect;
				fillerWidth = width / widthAspect;
			}
		}
		var translateStr = 'translate3d(' + ((item.options.position.percentageX || 0) * 100).toFixed(8) + '%, ' +
				((item.options.position.percentageY || 0) * 100).toFixed(8) + '%, 0px)' +
				' scale(' + (item.options.scale || 1) + ')';
		var imageSize = item.getSizeWithRotation();
		var newImageSize = this._resizeImageToFitContainer(imageSize.width, imageSize.height, Math.floor(width), Math.floor(height), angle);

		return {
			wrapper: wrapperStyle,
			imageHolder: {
				width: Math.floor(width),
				height: Math.floor(height),
				maxWidth: Math.floor(width),
				maxHeight: Math.floor(height),
				top: fillerWidth > 0 ? Math.floor((fillerWidth - width) / 2) : 0,
				left: fillerWidth ? Math.floor((fillerWidth - width) / 2) : 0
			},
			image: {
				width: Math.floor(newImageSize.width),
				height: Math.floor(newImageSize.height),
				maxWidth: Math.floor(newImageSize.width),
				maxHeight: Math.floor(newImageSize.height),
				transform: translateStr,
				WebkitTransform: translateStr
			},
			filler: {
				width: fillerWidth,
				height: fillerHeight,

				'wrapper' : {
					width: Math.floor(fillerWidth),
					height: Math.floor(fillerHeight)
				},
				'left' : {
					height: '100%',
					width: (fillerWidth - width) / 2
				},
				'right' : {
					height: '100%',
					width: (fillerWidth - width) / 2
				},
				'top' : {
					height: (fillerWidth - width) / 2
					//width: fillerWidth
				},
				'bottom' : {
					//width: fillerWidth,
					height: (fillerHeight - height ) - (fillerWidth - width) / 2
				}
			},
			wrapper: {
				width: fillerWidth > 0 ? Math.floor(fillerWidth) : Math.floor(width),
				height: fillerHeight > 0 ? Math.floor(fillerHeight) : Math.floor(height)
			}
		};
	},

	render: function() {
		var prodKey, showLabel;
		// The prodKey that would be used if an product has customSettings
		prodKey = (this.props.item.options.productHeight + 'x' + this.props.item.options.productWidth).toString();
		var settings = this.getPreviewStyle(),
			prodOptions = ProductStore.getProductById(this.props.item.productId).options;

		if(prodOptions.customSettings) {
			if(prodOptions.customSettings[prodKey]) {
				var customSettings = this.props.item.getCustomSettings();
				showLabel = customSettings.polaroid ? customSettings.polaroid : false;
			}
		}

		return (
			<div className="ope-preview__wrapper" style={settings.wrapper}>
				<div className={"ope-preview__image " + "this.props.imageClass"} style={settings.imageHolder}>
				{ this.props.imageSource ?
					<img src={this.props.imageSource} alt="" style={settings.image} /> :
					<div className="fake-image"></div>
				}
				</div>
				<div className="ope-preview__filler" style={settings.filler.wrapper}>
					<div className="ope-preview__filler--top" style={settings.filler.top}></div>
					<div className="ope-preview__filler--left" style={settings.filler.left}></div>
					<div className="ope-preview__filler--right" style={settings.filler.right}></div>
					<div className="ope-preview__filler--bottom" style={settings.filler.bottom}>
						{ showLabel ?
							<span className="ope-preview__label ">{this.props.item.options.polaroidText}</span> :
							<span />
						}
					</div>
				</div>
			</div>
		);
	}
});

export default OrderImagePreview;
